<template>
  <div class="border rounded attachment">
    <div class="attachment__item-container p-12px gap-12px" v-for="file in files" :key="file.id">
      <i v-if="file.extension === 'pdf'" class="bx bxs-file-pdf" style="font-size: 24px"></i>
      <i v-else class="bx bxs-image" style="font-size: 24px"></i>
      <div class="meta">
        <div class="file-name text-truncate">{{ baseName(file.path) }}</div>
        <div class="file-size">{{ $numeral(file.size / 1024).format("0,0.[00]") }} KB</div>
      </div>
      <a :href="file.url" target="_blank">
        <b-button variant="link">View</b-button>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    files: {
      type: [Array],
      default: () => []
    }
  },
  methods: {
    baseName(path = "") {
      return path.split(/[\\/]/).pop();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/design/colors";
.attachment {
  &__item-container {
    &:not(:last-child) {
      border-bottom: 1px solid #eaecf0;
    }
    display: flex;
    align-items: center;
    .file-name {
      font-family: Inter;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
    }
    .file-size {
      font-family: Inter;
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      color: #737373;
    }
    .meta {
      width: 61%;
      flex-grow: 1;
    }
  }
}
</style>
